import {
  AuthApplicationModel,
  IAuthApplicationModel,
} from '@common/models/Security';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from './serviceHelper';
import { ServiceMethodOptions } from './types';

export class AuthApplicationService {
  private static baseUrl: string = '/api/authapplication';

  static getAuthApplications = (
    options?: ServiceMethodOptions,
  ): Promise<AuthApplicationModel[]> => {
    return trackPromise(
      new Promise<IAuthApplicationModel[]>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .get<IAuthApplicationModel[]>()
          .then((response) => {
            ServiceHelper.showSuccess('Pet Alert updated', options);
            const apps = response.map((app) => new AuthApplicationModel(app));
            resolve(apps);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Pet Alert.', options);
            reject(err);
          });
      }),
    );
  };
}
